import { useEffect, useState } from 'react';
import { Label, SummaryList } from "nhsuk-react-components";
import { useNavigate } from "react-router-dom";
import { downloadPdfFile, setGeneratedBlobUrl } from "../../../Helper/Utility";
import '../../../Content/css/nhsuk-common.css';
import { useAppSelector } from "../../../state/app/hooks";
import { IApplication, IUserDetails } from "../../../state/models/app.interface";
import { getDSADetails } from "../../../state/slice/DSA/DSA.slice";
import { getUserDetails } from "../../../state/slice/Header/Header.slice";
import Attachment from "../../../Components/Attachment/Attachment";
import Loader from '../../../Components/Loader/Loader';
import { dsaContent } from '../../../config/page.config'
import GoBack from '../../../Components/Shared/GoBack';

const DSADownload: React.FC = () => {
    const navigate = useNavigate();
    const [blobUrl, setBlobUrl] = useState('');
    const [loading, setLoading] = useState(true);
    const UserDetailsData: IUserDetails = useAppSelector(getUserDetails);
    const initialStateofUserData: IUserDetails = UserDetailsData || {};
    const [userData, setUserData] = useState(initialStateofUserData);
    const dsaApplicationDetails: IApplication = useAppSelector(getDSADetails);
    const initialApplicationState: IApplication = dsaApplicationDetails || {};
    const [dsaApplicationData] = useState(initialApplicationState);
    const [downloadClicked, setDownloadClicked] = useState(false);
    const abortController = new AbortController();

    const getVersionNumber = () => dsaApplicationData?.referenceNumber?.split('-')[dsaApplicationData?.referenceNumber?.split('-').length - 1];

    const getDsaPDFFile = () => {
        downloadPdfFile(abortController,dsaApplicationData?.id!, dsaApplicationData?.referenceNumber!, setBlobUrl);
    }

    const handleDownload = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        event.preventDefault();
        setDownloadClicked(true);
    }

    useEffect(() => {
        getDsaPDFFile();
        setUserData(UserDetailsData);
        setLoading(false);
    }, [UserDetailsData]);

    useEffect(() => {
        if (downloadClicked && blobUrl) {
            setGeneratedBlobUrl(blobUrl);
            setDownloadClicked(false);
        }
    }, [downloadClicked, blobUrl]);

    useEffect(() => {
        return (() => {
            abortController.abort();
        });
    }, [navigate]);

    return (
        <>
            <div className="nhsuk-width-container">
                <main className="nhsuk-main-wrapper " id="maincontent" role="main">
                    <div className="nhsuk-grid-row">
                        {loading ?
                            <div className="nhsuk-grid-column-full">
                                <Loader loadingText={dsaContent.txtLoading} />
                            </div>
                            :
                            <div className="nhsuk-grid-column-two-thirds">
                                <GoBack />
                                <span className="nhsuk-caption-l nhsuk-caption--bottom">
                                    {userData?.userOrgName}
                                </span>
                                <p></p>
                                <p></p>
                                <h1>Your application for a Data Sharing Agreement</h1>
                                <Label size="m">Your application</Label>
                                <SummaryList noBorder>
                                    <SummaryList.Row>
                                        <SummaryList.Key>Reference number</SummaryList.Key>
                                        <SummaryList.Value>{dsaApplicationData?.referenceNumber}</SummaryList.Value>
                                    </SummaryList.Row>
                                    <SummaryList.Row>
                                        <SummaryList.Key>Title</SummaryList.Key>
                                        <SummaryList.Value>{dsaApplicationData?.title ? dsaApplicationData?.title : '-'}</SummaryList.Value>
                                    </SummaryList.Row>
                                    <SummaryList.Row>
                                        <SummaryList.Key>First submitted</SummaryList.Key>
                                        <SummaryList.Value>{dsaApplicationData?.firstSubmitDate ? dsaApplicationData?.firstSubmitDate : '-'}</SummaryList.Value>
                                    </SummaryList.Row>
                                </SummaryList>
                                <Label>Once you have downloaded your application for a Data Sharing Agreement (DSA), consider changing the file name to something that will help you easily locate it.</Label>
                                <p></p>
                                <p></p>
                                <Attachment>
                                    <Attachment.Thumbnail>
                                    </Attachment.Thumbnail>
                                    <Attachment.Details>
                                        <Attachment.Heading>
                                            <p>
                                                <Attachment.Link href="#" target="_blank" className={downloadClicked ? "nhsuk-link-spinner nhsuk_download_spinner" : ""} onClick={handleDownload}>Application for a Data Sharing Agreement {getVersionNumber()}</Attachment.Link>
                                            </p>
                                        </Attachment.Heading>
                                        <Attachment.Content >
                                            <Attachment.Property>PDF</Attachment.Property>,   <Attachment.Property>less than 1 MB</Attachment.Property>
                                        </Attachment.Content>
                                    </Attachment.Details>
                                </Attachment>
                            </div>
                        }
                    </div>
                </main>
            </div>
        </>
    )
}

export default DSADownload